import { TailSpin, TailSpinProps } from "react-loader-spinner";

export const Loader = (props: TailSpinProps) => {
    return <TailSpin {...props} color={"#b11312"} />;
};
